module.exports = __webpack_public_path__ + "img/part3-icon.2bc6c638.png";